var _ellipse, _rect, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.993,
    cy: 14.7907,
    rx: 15.9088,
    ry: 7.50413,
    fill: "#FFF67D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0842285,
    y: 8.48682,
    width: 31.8175,
    height: 6.30347,
    fill: "#FFF67D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.993,
    cy: 8.48704,
    rx: 15.9088,
    ry: 7.50413,
    fill: "#FFD54B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6971 12.5015C13.1595 12.5015 9.5718 12.1239 7.58838 11.3798L9.51347 10.2692C11.3219 10.88 13.5386 11.1688 15.6971 11.1688C18.643 11.1688 19.9848 10.8245 19.9848 10.1804C19.9848 8.72546 8.46342 9.18081 8.46342 6.53756C8.46342 5.09376 11.4969 4.16085 16.0763 4.16085C19.5764 4.16085 21.8807 4.66062 23.8641 5.3381L21.7057 6.31543C20.0139 5.78234 18.2347 5.49358 16.2513 5.49358C14.0637 5.49358 12.5761 5.79345 12.5761 6.4265C12.5761 7.80365 24.0975 7.3372 24.0975 10.036C24.0975 11.4909 21.064 12.5015 15.6971 12.5015ZM14.7637 4.70505V2.78369H17.6222V4.70505L14.7637 4.70505ZM14.7637 13.8898V11.8463H17.6222V13.8898H14.7637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.7cb2545e962c1b289b5eedcdbc26229c.svg";
export { ForwardRef as ReactComponent };